import { create } from 'zustand';

export interface TenantSettings {
  company_name: string;
  logo_url?: string;
  primary_color: string;
  email_provider: string;
  email_address?: string;
  email_provider_status: 'ok' | 'error';
  storage_provider: 'firebase_storage' | 'google_drive';
  invoice_prefix: string;
  offer_prefix: string;
  tps_rate: number;
  tvq_rate: number;
  default_margin_percentage: number;
  project_statuses: string[];
  project_types: string[];
  project_categories: string[];
  project_sectors: string[];
  frais_kilometrage: number;
  responsable_user_id?: string | null;
  fiscal_year_start: string; // format "MM-DD", e.g. "07-01" for July 1
  salaire_formateur_lq?: number | null;
  salaire_formateur_nlq?: number | null;
  salaire_formateur_retraite?: number | null;
  gestion_erreurs_nom?: string | null;
  gestion_erreurs_courriel?: string | null;
}

const DEFAULT_TENANT: TenantSettings = {
  company_name: 'ProjetSAE',
  primary_color: '#1677ff',
  email_provider: 'gmail',
  email_provider_status: 'ok',
  storage_provider: 'firebase_storage',
  invoice_prefix: 'FAC-',
  offer_prefix: 'OFF-',
  tps_rate: 5.0,
  tvq_rate: 9.975,
  default_margin_percentage: 40.0,
  project_statuses: ['Prospect', 'Planification', 'En production', 'Clôturé', 'Annulé'],
  project_types: [],
  project_categories: [],
  project_sectors: [],
  frais_kilometrage: 64,
  fiscal_year_start: '01-01',
};

interface TenantState {
  tenant: TenantSettings;
  setTenant: (tenant: TenantSettings) => void;
}

const useTenantStore = create<TenantState>()((set) => ({
  tenant: DEFAULT_TENANT,
  // Merge with defaults so that new fields added to TenantSettings never
  // arrive as `undefined` if an older Firestore config doc is missing them.
  setTenant: (tenant) => set({ tenant: { ...DEFAULT_TENANT, ...tenant } }),
}));

export default useTenantStore;
